import { css } from "@emotion/react"
import React from "react"
import { resetStyleButton } from "../../components/styles"
import { theme } from "../../theme"

const controllButtonStyle = css`
    width: 32px;
    height: 32px;
    @media (max-width: ${theme.breakpoints.sm}px) {
        width: 42px;
        height: 42px;
    }
`

export const ControllButton: React.FC<
    React.ComponentProps<"button">
> = props => {
    return <button css={[controllButtonStyle, resetStyleButton]} {...props} />
}
